import StoreUtils from "./StoreUtils";
import router from "../../router/router";

class RouterUtils {
  static routes = {
    auth: {
      LOGIN: "login",
      FORGOT_PASSWORD: "forgot-password",
      NEW_PASSWORD: "new-password",
      ENROLLMENT: "enrollment",
      RESET: "reset",
      CUSTOMER_DASHBOARD: "customer-dashboard",
      CUSTOMER_MESSAGES: "customer-messages",
      CUSTOMER_FEEDS: "customer-feeds",
      CUSTOMER_SETTINGS: "customer-settings",
      CUSTOMER_WALLET: "customer-wallet",
      CUSTOMER_BOOKINGS: "customer-bookings",
      CUSTOMER_SUBSCRIPTIONS: "customer-subscriptions",
      CUSTOMER_SUPPORT: "customer-support",
      CUSTOMER_PROFILE: "customer-profile",
      DISCOVER: "discover",
      PROFESSIONAL_PROFILE: "professional-profile",
      BECOME_A_PROFESSIONAL: "become-a-professional",
      PROFESSIONAL_DASHBOARD: "professional-dashboard",
      PROFESSIONAL_MESSAGES: "professional-messages",
      PROFESSIONAL_FEEDS: "professional-feeds",
      PROFESSIONAL_SETTINGS: "professional-settings",
      PROFESSIONAL_WALLET: "professional-wallet",
      PROFESSIONAL_BOOKINGS: "professional-bookings",
      PROFESSIONAL_SUBSCRIPTIONS: "professional-subscriptions",
      PROFESSIONAL_SUPPORT: "professional-support",
      OTP: "verify-email",
      ACCOUNT_SUCCESS: "success",
      RESET_PASSWORD: "reset-password",
      CHANGE_PASSWORD: "change-password",
      RESET_OTP: "confirm-email",
      RESET_SUCCESS: "reset-success",
      PAYMENT_VIEW: "payment-view"
    },
    HOME: {
      APPLICANT: "applicant"
    },
    PRODUCTDETAILS: "product-details",
    recruiter: {
      RECRUITER_HOME: "recruiter-home"
    }
  };
  static changeBaseRouteTo(targetRoute) {
    StoreUtils.dispatch(StoreUtils.actions.router.setActiveRoute, targetRoute);
    router.push({
      name: targetRoute
    });
  }

  static changeRouteTo(targetRoute) {
    router.push({
      name: targetRoute
    });
  }

  static goBackOnce() {
    router.go(-1);
  }

  static replaceRoute(targetRoute) {
    router.replace(targetRoute);
  }

  static goBack(numberOfSteps) {
    router.go(numberOfSteps);
  }

  static changeActivePageTo(targetRoute) {
    StoreUtils.dispatch(StoreUtils.actions.router.setActiveRoute, targetRoute);
  }
  static changeRouteUrlTo(targetUrl) {
    router.push(targetUrl);
  }
}
export default RouterUtils;
